import { useLocalSearchParams } from 'expo-router';

import SpinwheelGenericError from '../../../../onboarding/components/spinwheel/SpinwheelGenericError';

export default function SpinwheelGenericErrorScreen() {
    const params = useLocalSearchParams<{
        title?: string;
        description?: string;
        primaryButtonText?: string;
        primaryButtonRoute?: string;
        secondaryButtonText?: string;
    }>();

    return (
        <SpinwheelGenericError
            title={params.title}
            description={params.description}
            primaryButtonText={params.primaryButtonText}
            primaryButtonRoute={params.primaryButtonRoute}
            secondaryButtonText={params.secondaryButtonText}
        />
    );
}
